import cn from 'classnames';
import { formatCentsToDollars } from '../../../../services/formatCentsToDollars';
import styles from './SelectPlanCard.module.scss';

export const SelectPlanCard = ({content,currency,status,selectedPlanText,...props})=>{
    const { title,popular, fullPrice, salePrice,focusPrice, focusPricePeriod} = content;
      const full = formatCentsToDollars(fullPrice);
      const sale = formatCentsToDollars(salePrice);
      const focus = formatCentsToDollars(focusPrice);
  return(
    <>
    <div className={cn(
        styles.card,
        status==='active' && styles.active
      )}  {...props}>
        {status==='active' ? 
          <div className={styles.selectedPlanText}>{popular ? popular : selectedPlanText}</div>
          : 
          (popular && <div className={styles.selectedPlanText}>{popular}</div>)
        }
        <div className={styles.wrapper}>
          <div className={styles.mainInfo}>
            {title && <div className={styles.title}>{content.title}</div>}
            <div className={styles.prices}>
              <div className={styles.fullPrice}>{currency} {full.integer}.{full.fraction}</div>
              <div className={styles.salePrice}>{currency} {sale.integer}.{sale.fraction}</div>
            </div>
          </div>
          <div className={styles.focusPrice}>
            <div className={styles.newPriceWrapper}>
              <span className={styles.currency}>{currency}</span>
              <span className={styles.main}>{focus.integer}</span>
              <span className={styles.fraction}>
                <span className={styles.fractionPrice}>
                  {focus.fraction}
                </span>
                <span className={styles.period}>{focusPricePeriod}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
// const selectedStar = ()=>{
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
//     <path d="M4.82441 0.321957C4.90021 0.182969 5.09979 0.182969 5.17559 0.321957L6.51217 2.77276C6.54094 2.8255 6.59189 2.86252 6.65095 2.87358L9.39482 3.38741C9.55043 3.41655 9.6121 3.60636 9.50334 3.7214L7.58552 5.74991C7.54425 5.79356 7.52479 5.85346 7.53252 5.91304L7.89174 8.68141C7.91211 8.83841 7.75065 8.95571 7.60763 8.88782L5.08577 7.69071C5.03149 7.66495 4.96851 7.66495 4.91423 7.69071L2.39237 8.88782C2.24935 8.95571 2.08789 8.83841 2.10826 8.68141L2.46748 5.91304C2.47521 5.85346 2.45575 5.79356 2.41448 5.74991L0.496658 3.7214C0.387896 3.60636 0.449567 3.41655 0.605176 3.38741L3.34905 2.87358C3.40811 2.86252 3.45906 2.8255 3.48783 2.77276L4.82441 0.321957Z" fill="white"/>
//     </svg>
//   )
// }